import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BookingStore, InstallationsStore } from '@store';

@Component({
  selector: 'app-booking-overview-voucher',
  templateUrl: './booking-overview-voucher.component.html',
  styleUrls: ['./booking-overview-voucher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingOverviewVoucherComponent {
  constructor(public bookingStore: BookingStore, public installationsStore: InstallationsStore) {}
}
